import React from 'react'
import Navbar from '../../Pages/Navbar/Navbar'

function FAQs() {
  return (
    <>
    <Navbar/>
    <div style={{marginTop:'70px'}}>
    <div>FAQs</div>
    </div>
    </>
  )
}

export default FAQs